import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

type FormCheckboxFieldProps = {
  id: string;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

export function FormCheckboxField({
  id,
  label,
  description,
  checked,
  onChange,
  disabled = false,
}: FormCheckboxFieldProps) {
  return (
    <div className="grid gap-1">
      <div className="flex items-center gap-2">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={(ch) => onChange(ch === true)}
          disabled={disabled}
        />
        <Label htmlFor={id} className="font-medium text-gray-900 cursor-pointer">
          {label}
        </Label>
      </div>
      {description && (
        <p className="text-detail text-gray-500 leading-tight ml-6">{description}</p>
      )}
    </div>
  );
}
